import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  const content = `개인정보 처리방침


주식회사 마이즈 (이하 ‘회사는) 정보통신망이용촉진 및 정보보호 등에 관한 법률(이하’정보통신망법’)등에 따라 회원의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침을 수립·공개합니다.	

제 1 조 【개인정보의 수집 및 이용 목적】
① 회사는 다음과 같이 회원의 개인정보를 수집, 이용하고 있습니다.. 
 (1) 회원가입시 이 과정에서 휴대폰번호, 로그인ID, 비밀번호(이상 필수적 수집 정보), 이름, 생년월일, 성별, 이메일, 자택주소(이상 선택적 수집정보)을 수집합니다. 
 (2) 관리자 회원의 경우, 회원가입 직후 정보 등록 과정에서 필수항목으로 사업장명, 사업자번호, 대표자명, 이메일 주소, 휴대폰번호, 주소 등의 공간정보와 선택항목으로 유선전화번호, 계좌번호(은행명, 계좌번호, 예금주)를 수집합니다.
 (3) 문의 접수 및 회신 과정에서 연락처 및 이메일 주소를 수집 할 수 있으며, 이벤트 진행 시 배송정보 등을 수집할 수 있습니다.
② 회사는 다음의 목적으로 서비스 제공을 위한 최소한의 개인정보만을 수집하며, 수집한 정보를 목적 외로 이용하거나, 회원의 동의 없이 외부에 공개하지 않습니다.
 (1) 홈페이지 회원 가입 및 관리 
 (2) 재화 또는 서비스 제공
 (3) 고지사항 전달/불만 처리 등을 위한 원활한 의사소통 경로의 확보
 (4) 개인정보 침해 사고에 대한 대비, 분쟁 조정을 위한 기록 보존

제 2 조 【개인정보의 수집 방법 및 수집 동의】
회사는 서비스 계약의 성립 및 이행에 필요한 최소한의 개인정보를 수집합니다. 회사는 회원의 개인식별이 가능한 개인정보를 수집하는 때는 반드시 아래의 적법한 절차에 따라 당해 회원의 동의를 받습니다..
① 개인정보 수집 방법 
 (1) 회사가 운영중인 홈페이지(모바일 웹, 앱 포함)를 통한 수집
 (2) 생성정보 수집 툴을 통한 수집(접속로드, 쿠키 등)
② 개인정보 수집에 대한 동의 절차
회원의 개인정보 수집과 관련하여 회사는 개인정보처리방침 또는 이용약관을 통해 그 내용을 고지하고 있으며, 회원에게 수집하는 개인정보의 항목과 이용목적 및 보유기간, 거부권에 대해 고지 후 회원이 가입을 할 때, 해당 내용에 대해 「동의」 버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.
③ 목적 외 사용 및 제3자에 대한 제공 및 공유에 대한 동의
회사는 회원의 동의가 있거나 관련법령의 규정에 의한 경우를 제외하고는 어떠한 경우에도 본 개인정보처리방침에서 고지한 범위를 넘어 회원의 개인정보를 이용하지 않습니다.
본 개인정보처리방침에 의한 회원의 개인정보 제공 및 공유에 추가하여 개인정보를 제공하거나 공유하는 경우에는 사전에 회원에게 제공하거나 공유하는 자가 누구이며 주된 사업이 무엇인지, 제공 또는 공유되는 개인정보항목이 무엇인지, 개인정보를 제공하거나 공유하는 목적이 무엇인지, 공유하는 정보의 보유 및 이용기간 등에 대해 이용약관, 개인정보처리방침, 이메일, 서면, 전화 중 하나를 통해 고지한 후 이에 대한 동의를 구합니다.
다만, 다음의 경우에는 관련 법령의 규정에 의하여 회원의 동의 없이 개인정보를 제공하는 것이 가능합니다.
 (1) 통계작성•학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우 
 (2) 금융 실명 거래 및 비밀보장에 관한 법률, 신용정보의 이용 및 보호에 관한 법률, 전기통신기본법, 전기통신사업법, 지방세법, 소비자보호법, 한국은행법, 형사소송법 등 법률에 특별한 규정이 있는 경우 
 (3) 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우

제 3 조 【개인정보의 보유 및 이용기간】
회사는 개인정보의 수집 및 제공받은 목적이 달성되어 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기함을 원칙으로 합니다. 다만, 관련 법령에 따라 일정기간 개인정보를 보관해야 할 수 있으며, 관련 법령에 따른 정보보유 사유는 아래와 같습니다. 
① 홈페이지 회원 가입 및 관리 : 사업자/단체 홈페이지 탈퇴 시까지
② 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
③ 웹사이트 방문 기록 : 3개월

제 4 조 【개인정보의 파기】
① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
② 정보주체로부터 동의 받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.
③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
 (1) 파기절차 :　정보주체가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우를 제외하고 다른 목적으로 이용되지 않습니다.
 (2) 파기방법 : 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.

제 5 조 【개인정보를 자동으로 수집하는 장치의 설치·운영 및 그 거부에 관한 사항】
① 회사는 이용자에게 개별적인 정보 보안을 위해 수시로 불러오는 ‘쿠키(cookie)’ 대신 '세션(Session)' 을 사용합니다.
② 세션은 쿠키를 기반하고 있지만, 사용자 정보 파일을 브라우저에 저장하는 쿠키와 달리 세션은 서버 측에서 관리합니다.
③ 서버에서는 클라이언트를 구분하기 위해 세션 ID를 부여하며 웹 브라우저가 서버에 접속해서 브라우저를 종료할 때까지 인증상태를 유지합니다.
④ 사용자에 대한 정보를 서버에 두기 때문에 쿠키보다 보안에 좋지만, 사용자가 많아질수록 서버 메모리를 많이 차지하게 됩니다.
⑤ 즉, 동접자 수가 많은 웹 사이트인 경우 서버에 과부하를 주게 되므로 이용에 어려움이 발생할 수 있습니다.

제 6 조 【개인정보의 보호조치에 관한 사항】
회사는 사용자의 개인정보가 분실, 도난, 변조, 유출 또는 훼손되지 않도록 다음과 같은 기술적, 관리적 보호 조치를 시행하고 있습니다.
① 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다. 
② 이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
③ 개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
④ 개인정보 취급 인력에 대한 보안 교육을 시행하고 관련 인력 및 시스템에 대한 점검을 시행하는 등 안전한 취급을 위해 최선을 다하고 있습니다.

제 7 조 【사용자의 권리와 의무】
회원은 개인정보를 최신의 상태로 정확하게 입력하여 불의의 사고를 예방할 수 있도록 협조해야 합니다. 저장된 부정확한 정보로 인해 발생하는 사고의 책임은 회원에게 있으며, 타인 정보의 도용 등 허위 정보를 입력할 경우 회원 자격이 상실될 수 있습니다.
회원은 개인정보를 보호받을 권리와 함께 스스로를 보호하고 타인의 정보를 침해하지 않을 의무도 가지고 있습니다. 비밀번호를 포함한 회원의 개인정보가 유출되지 않도록 조심하시고 게시물을 포함한 타인의 개인정보를 훼손하지 않도록 유의하시기 바랍니다. 만약 이 같은 책임을 다하지 못하고 타인의 정보를 훼손할 시에는 ‘개인정보 보호법’ 및 ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’ 등 관련 법령에 의해 처벌받을 수 있습니다.

제 8 조 【개인정보 보호책임자에 관한 사항】
① 회원의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 회사는 개인정보보호책임자를 두고 있습니다. 개인정보와 관련한 문의사항이 있으시면 아래의 개인정보보호책임자에게 연락 주시기 바랍니다. 회원의 문의사항에 신속하고 성실하게 답변해 드리겠습니다.
▶ 개인정보 보호책임자
성명 : 김혜진 이사
연락처 : 1670-6640, mizeinc@mizecompany.co.kr
▶ 개인정보 보호 담당부서
부서명 : 전산부서
연락처 : 1670-6640, mizeinc@mizecompany.co.kr
② 회사는 귀하의 의견을 소중하게 생각하며, 귀하와의 원활한 의사소통을 위해 민원처리센터를 운영하고 있습니다. 민원처리센터 연락처는 다음과 같습니다.
▶ E-mail : mizeinc@mizecompany.co.kr
▶ 전화번호 : 1670-6640 (오전10시 ~ 오후 5시)
③ 개인정보 침해에 대한 신고 및 상담이 필요하신 경우에는 개인정보관리책임자에 E-mail, 전화 또는 서면으로 연락하시거나 개인정보침해신고센터, 경찰청 사이버테러대응센터 등으로 문의하시기 바랍니다.
- 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)

제 7 조 【개인정보 처리방침 변경 및 고지의무】
① 개인정보 처리방침은 법령 또는 회사의 정책에 따라 그 내용이 변경될 수 있으며, 내용의 추가 및 삭제, 수정이 있을 시에는 홈페이지를 통해 변경내용 및 사유를 공지하도록 하겠습니다.
② 본 개인정보 처리방침은 2022년 07월 01일 부터 시행되며, 종전의 개인정보 처리방침은 본 개인정보 처리방침으로 대체됩니다.
`;

  return (
    <div className="terms_page">
      <div className="terms_box">
        <h1 className="terms_title">개인정보 처리방침</h1>

        <div className="terms_content">{content}</div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
